import Checkbox from 'antd/lib/checkbox'
import CheckboxGroup from './checkbox-group'

import 'antd/lib/checkbox/style'

export * from 'antd/lib/checkbox'
// @ts-ignore
export * from './checkbox-group'

// @ts-ignore
Checkbox.Group = CheckboxGroup

export default Checkbox
